/**
 * Utility for clearing all flow-related data from localStorage.
 * Used during logout to ensure user data privacy and security.
 *
 * Delegates to `persistAdapter.clearAll()`, the canonical prefix-scan implementation —
 * this wrapper exists so logout call sites don't need to import from `engine/adapters/`.
 */
import { persistAdapter } from '@/flows/engine/adapters/persist'
import { registerPatientSessionDataInvalidator } from '@/utilities/auth/patientSession'

export function clearAllFlowData(): void {
  persistAdapter.clearAll()
}

registerPatientSessionDataInvalidator(() => {
  clearAllFlowData()
})
